"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.substitutePseudoFields = exports.pseudoInputs = void 0;
exports.pseudoInputs = {
    postcode: {
        type: "textNumber",
        formatters: [
            {
                formatPattern: /^(\w{4})$/,
                formatBlueprint: "$1",
                formatFilter: /[\s-]+$/
            }
        ],
        maxLength: 4,
        format: {
            pattern: /^(\d{4})$/,
            message: "must be a 4 digit number"
        }
    },
    individualHealthcareIdentifier: {
        type: "textNumber",
        formatters: [
            {
                maxLength: 16
            }
        ],
        format: {
            pattern: /^\d+$/,
            message: "is not a valid Individual Healthcare Identifier"
        },
        maxLength: 16,
        minLength: 16
    }
};
/**
 * Recursively iterates over the entire object, including nested objects and substitutes the pseudo field details
 */
const substitutePseudoFields = (schema) => schema.map(field => {
    const transformation = exports.pseudoInputs[field.type];
    // create a new object, regardless of whether we are modifying at this stage
    // as we may update it later in the function.
    const newField = transformation
        ? Object.assign(Object.assign({}, field), transformation) : Object.assign({}, field);
    // replace children with updated children
    if (newField.fields) {
        newField.fields = (0, exports.substitutePseudoFields)(newField.fields);
    }
    return newField;
});
exports.substitutePseudoFields = substitutePseudoFields;
//# sourceMappingURL=pseudoFields.js.map